import { Box } from '@mui/material';
import { useRosterState } from 'amazon-chime-sdk-component-library-react';

function stringToColor(string: string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

function DefaultUserIcon({
  name = 'A',
  hidden = false,
}: {
  name?: string;
  hidden?: boolean;
}) {
  const { roster: allRoster } = useRosterState();
  const gridSize = Object.values(allRoster).filter(
    (roster) => !roster.externalUserId?.startsWith('aws:MediaPipeline'),
  ).length;

  return (
    <Box
      sx={{
        display: hidden ? 'none' : 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
      }}
    >
      <Box
        sx={{
          borderRadius: '50%',
          color: '#FFFFFF',
          fontSize: gridSize > 1 ? '60px' : '80px',
          fontStyle: 'normal',
          fontWeight: '400',
          lineHeight: '125%',
          background: stringToColor(name),
          padding: gridSize > 1 ? '4%' : '2%',
          aspectRatio: '1/1',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        {name.charAt(0)}
      </Box>
    </Box>
  );
}

export default DefaultUserIcon;
